import React, { useMemo } from 'react';
import { Users, GitCompare, CheckCircle, UserCheck, Layers } from 'lucide-react';
import ApprobationsCrudShell from './ApprobationsCrudShell';
import {
  ENTITY_TYPES, WORKFLOW_STATUS, statusBadge, entityLabel, defaultStats,
  hasMeaningfulChainJson, hasMultiStepChain, mapRecordJsonFields,
} from './approbationsShared';

const NS = 'chaineApprobationPage';
const API = '/api/approbations/workflows';

const EMPTY = {
  workflow_code: '', name: '', chain_json: '[]', entity_type: '', status: 'actif', notes: '',
};

export default function ChaineApprobationPage() {
  const entityOpts = useMemo(() => ENTITY_TYPES.map((e) => ({ value: e.value, labelKey: e.labelKey })), []);
  const statusOpts = useMemo(() => WORKFLOW_STATUS.map((s) => ({ value: s.value, labelKey: s.labelKey })), []);

  return (
    <ApprobationsCrudShell
      ns={NS}
      icon={Users}
      apiPath={API}
      codeField="workflow_code"
      entityPrefixKey="approvalWorkflow"
      codePrefixFallback="WF"
      entityLabel="سلسلة الاعتماد"
      entityLabelPlural="سلاسل الاعتماد"
      gradient="from-purple-500 to-purple-700"
      emptyForm={EMPTY}
      mapRecordToForm={(r) => mapRecordJsonFields(r, EMPTY)}
      filterRecords={hasMeaningfulChainJson}
      computeStats={(records) => defaultStats(records, {
        totalIcon: Users,
        fields: [
          { titleKey: 'stat_active', field: 'status', value: 'actif', icon: CheckCircle, color: 'from-green-500 to-green-600' },
          { titleKey: 'stat_multi_step', match: hasMultiStepChain, icon: GitCompare, color: 'from-blue-500 to-blue-600' },
          { titleKey: 'stat_entities', field: 'entity_type', value: 'leave', icon: UserCheck, color: 'from-violet-500 to-violet-600' },
          { titleKey: 'stat_types', field: 'entity_type', value: 'invoice', icon: Layers, color: 'from-amber-500 to-amber-600' },
        ],
      })}
      columns={[
        { key: 'workflow_code', labelKey: 'col_code' },
        { key: 'name', labelKey: 'col_name' },
        { key: 'entity_type', labelKey: 'col_entity', render: (r, _p, _t, pl) => entityLabel(r.entity_type, pl) },
        { key: 'chain_json', labelKey: 'col_chain', render: (r) => (r.chain_json ? `${String(r.chain_json).slice(0, 40)}…` : '—') },
        { key: 'status', labelKey: 'col_status', render: (r, _p, _t, pl) => statusBadge(r.status, pl) },
      ]}
      formSections={[
        {
          id: 'identity',
          titleKey: 'section_identity',
          fields: [
            { key: 'name', labelKey: 'field_name', required: true },
            { key: 'entity_type', labelKey: 'field_entity_type', type: 'select', options: entityOpts },
            { key: 'status', labelKey: 'field_status', type: 'select', options: statusOpts },
          ],
        },
        {
          id: 'chain',
          titleKey: 'section_chain',
          fields: [
            { key: 'chain_json', labelKey: 'field_chain_json', type: 'chain_steps', fullWidth: true },
            { key: 'notes', labelKey: 'field_notes', type: 'textarea', fullWidth: true },
          ],
        },
      ]}
      mapFormToPayload={(f) => ({
        workflow_code: f.workflow_code,
        name: (f.name || '').trim(),
        entity_type: f.entity_type || null,
        chain_json: f.chain_json || '[]',
        status: f.status || 'actif',
        notes: f.notes || null,
      })}
    />
  );
}
